export class SearchCriteria {
  sortOrder: string;
  statuses: string[] = [];
  lastName: string;
  invoiceNumber: string;
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/data/search-criteria.ts